<template>
  <router-link :to="toUrl" style="textDecoration: none;" class="ServiceProduct">
    <div class="ServiceProduct__textCover">
      <div class="ServiceProduct__image">
        <img :src="data.image.url" alt="" />
      </div>
      <h1 class="ServiceProduct__title">{{ data.title }}</h1>
      <p class="ServiceProduct__text">{{ data.description }}</p>
      <span
        class="ServiceProduct__button myPaBoxButton v-btn v-btn--depressed theme--light v-size--default info"
        ><span class="v-btn__content">{{ data.cta }}</span></span
      >
    </div>
  </router-link>
</template>

<script>
import { handleize } from "@/lib/utils";
export default {
  name: "ServiceProduct",
  props: ["data"],
  data() {
    return {};
  },
  computed: {
    toUrl() {
      return `/services/${handleize(this.data.title)}`;
    }
  },
  methods: {
    // showNextStep (event) {
    //   this.$emit('onSubmit', {
    //       selectedEvent : event
    //   })
    // }
  }
};
</script>

<style scoped>
.ServiceProduct {
  background-color: #bacdd9;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
/* .ServiceProduct:nth-child(even) {
    flex-direction: row-reverse;
    margin: 30px auto;
    text-align: right;
} */
.ServiceProduct__textCover {
  position: relative;
  z-index: 2;
  height: 100%;

  display: flex;
  flex-direction: column;
}
.ServiceProduct__image {
  position: relative;
  overflow: hidden;
}
.ServiceProduct__image::before {
  content: "";
  display: inline-block;
  padding-bottom: 65%;
}
.ServiceProduct__image img {
  display: block;
  width: 100%;
  position: absolute;
  top: 0%;
  left: 0%;
  object-fit: cover;
  height: 100%;
}
.ServiceProduct__image::after {
  z-index: 1;
  content: "";
  position: absolute;
  bottom: 10px;
  right: -10px;
  width: 1000px;
  height: 50px;
  display: block;
  background-color: #bacdd9;
  transform: rotate(7deg);
}

.ServiceProduct__title {
  font-size: 20px;
  line-height: 1.3;
  color: #191340;
  padding-bottom: 41px;
  position: relative;
  padding: 8px 32px 16px;
}
/* .ServiceProduct__title::before {
    content: '';
    background-color: #191340;
    height: 2px;
    width: 30px;
    display: block;
    position: absolute;
    bottom: 16px;
    left: 32px;
} */

.ServiceProduct__text {
  color: #191340;
  padding: 0 32px;
}

.myPaBoxButton {
  background-color: #191340 !important;
  border-color: #191340 !important;
}
.ServiceProduct__button {
  margin-top: auto;
  margin: auto 32px 32px;
}

@media (max-width: 900px) {
  .ServiceProduct {
    max-width: 100%;
  }

  .ServiceProduct__image {
    display: none;
  }

  .ServiceProduct__textCover {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServiceProduct.vue